import React, { useEffect, useState } from "react";
import "./BlogPage.scss";
import Container from "../../shared/ui/Container";
import { getBlogPosts } from "./lib/getBlogPosts";
import { Link } from "react-router-dom";
const BlogPage = () => {
  const [blogPosts, setBlogPosts] = useState([]);

  useEffect(() => {
    getBlogPosts().then(setBlogPosts);
  }, []);

  return (
    <div className="blog-page">
      <section className="page-header" aria-labelledby="page-title">
        <Container>
          <h1 id="page-title" className="page-header__title">
            Blog
          </h1>
          <p className="page-header__subtitle">
            Insights, tips, and best practices for web accessibility.
          </p>
        </Container>
      </section>

      <section className="blog-section" aria-labelledby="blog-title">
        <div className="blog-grid">
          {blogPosts.map((post) => (
            <article key={post.sys.id} className="blog-card">
                <span
                  className="blog-card__date"
                  aria-label={`Date: ${post.fields.date}`}
                >
                  {post.fields.date}
                </span>
              <h2 className="blog-card__title">{post.fields.title}</h2>
              <Link
                to={`/blog/${post.fields.slug}`}
                className="blog-card__link"
                aria-label={`Read more about ${post.fields.title}`}
              >
                Read More <span aria-hidden="true">→</span>
              </Link>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
